var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#download_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11v2a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2v-2M8.5 1.75v8.5M12 7l-3.124 3.57a.5.5 0 0 1-.752 0L5 7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "download_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5 0h16v16H.5z"
  })))));
};
export default SvgDownload;